import { Record, List } from 'immutable'
import { STORIES_PROTRACK_FILTER_DEFAULT_ID } from 'app/constants/stories'

export const PendingRecord = Record({
  getStories: false,
  getStoriesLoadMore: false,
})

export class Pending extends PendingRecord {}

export const LoadedRecord = Record({
  getStories: false,
  getStoriesLoadMore: false,
})

export class Loaded extends LoadedRecord {}

export const StoriesPaginationRecord = Record({
  count: 0,
  limit: 30,
  page: 0,
})

export class StoriesPagination extends StoriesPaginationRecord {}

export const StoriesRecord = Record({
  stories: List(),
  pending: new Pending(),
  loaded: new Loaded(),
  storiesPagination: new StoriesPagination(),
  scrollTop: 0,
  proTracks: List(),
  proTrackId: STORIES_PROTRACK_FILTER_DEFAULT_ID,
})

export class Stories extends StoriesRecord {}
